import { render, staticRenderFns } from "./vedioid__list.vue?vue&type=template&id=d8576b02"
import script from "./vedioid__list.vue?vue&type=script&lang=js"
export * from "./vedioid__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports